import React, { Component, Fragment } from 'react';

class JobList extends Component {
    state = {
        sortColumn: null,
        sortDirection: 'asc',
    };

    handleSort = (column) => {
        const { sortColumn, sortDirection } = this.state;
        let newDirection = 'asc';
        if (sortColumn === column && sortDirection === 'asc') {
            newDirection = 'desc';
        }
        this.setState({ sortColumn: column, sortDirection: newDirection });
    };

    sortData = (data) => {
        const { sortColumn, sortDirection } = this.state;
        if (!sortColumn) return data;

        const sortedData = [...data].sort((a, b) => {
            let aValue = a[sortColumn];
            let bValue = b[sortColumn];

            if (sortColumn === 'job_type') {
                aValue = a.job_type?.name || '';
                bValue = b.job_type?.name || '';
            } else if (sortColumn === 'operative') {
                aValue = a.job_route?.team_member
                    ? `${a.job_route.team_member.first_name} ${a.job_route.team_member.last_name}`
                    : '';
                bValue = b.job_route?.team_member
                    ? `${b.job_route.team_member.first_name} ${b.job_route.team_member.last_name}`
                    : '';
            } else if (sortColumn === 'customer') {
                aValue = a.customer?.name || '';
                bValue = b.customer?.name || '';
            }

            if (typeof aValue === 'string') aValue = aValue.toLowerCase();
            if (typeof bValue === 'string') bValue = bValue.toLowerCase();

            if (aValue > bValue) return sortDirection === 'asc' ? 1 : -1;
            if (aValue < bValue) return sortDirection === 'asc' ? -1 : 1;
            return 0;
        });

        return sortedData;
    };

    renderSortIcons = (column) => {
        const { sortColumn, sortDirection } = this.state;

        if (sortColumn === column) {
            return (
                <span style={{ marginLeft: '5px' }}>
                    <i
                        className={`fas fa-chevron-up${sortDirection === 'asc' ? '' : ' text-muted'}`}
                        style={{ marginRight: '2px' }}
                    ></i>
                    <i className={`fas fa-chevron-down${sortDirection === 'desc' ? '' : ' text-muted'}`}></i>
                </span>
            );
        }

        return (
            <span style={{ marginLeft: '5px', opacity: 0.4 }}>
                <i className="fas fa-chevron-up" style={{ marginRight: '2px' }}></i>
                <i className="fas fa-chevron-down"></i>
            </span>
        );
    };

    render() {
        const { data, manager_review, onClick, markComplete, onDelete, toggleOnHold } = this.props;
        const displayStatus = (job) => {
            if (Number(job.waste_journey) === 1 || job.status === 'wasted_journey') {
                return 'Wasted journey';
            }

            if (job.status === 'follow-on') {
                return 'Follow-on';
            }

            return job.status?.replace('_', ' ');
        };

        const sortedJobs = this.sortData(data);
        const jobs = sortedJobs.map((job, index) => (
            <tr key={index}>
                <td>
                    {job.app_job ? <i class="fas fa-phone"></i> : ''}
                    {job.id}
                </td>
                <td>{job.display_job_type_name || job.job_type?.name || 'N/A'}</td>
                <td>{job.customer?.name || 'N/A'}</td>
                <td>{job.address_line_1}</td>
                <td>{job.postcode}</td>
                <td>{job.city}</td>
                <td>
                    {job.job_route?.team_member
                        ? `${job.job_route.team_member.first_name} ${job.job_route.team_member.last_name}`
                        : 'None'}
                </td>
                {manager_review && (
                    <td>
                        {job.manager_review_flag_reason ??
                            (job.manager_review_reason ? `D - ${job.manager_review_reason}` : 'manual')}
                    </td>
                )}

                <td>{displayStatus(job)}</td>
                <td>
                    <button
                        title="View"
                        onClick={() => {
                            const viewUrl = job.status === 'done' ? `/jobs/${job.id}/dtn/edit` : `/jobs/${job.id}`;

                            if (this.props.superadmin_review) {
                                const remainingJobs = sortedJobs
                                    .slice(index + 1)
                                    .map((nextJob) =>
                                        nextJob.status === 'done'
                                            ? `/jobs/${nextJob.id}/dtn/edit`
                                            : `/jobs/${nextJob.id}`
                                    );

                                sessionStorage.setItem('superadmin_review_queue', JSON.stringify(remainingJobs));
                                sessionStorage.setItem('superadmin_review_active', '1');
                            } else {
                                sessionStorage.removeItem('superadmin_review_queue');
                                sessionStorage.removeItem('superadmin_review_active');
                            }

                            onClick(viewUrl);
                        }}
                        className="btn btn-link btn-info"
                    >
                        <i className="fas fa-eye"></i>
                    </button>

                    {/* Mark Complete */}
                    {(job.status === 'done' ||
                        job.status === 'wasted_journey' ||
                        job.status === 'follow-on' ||
                        Number(job.waste_journey) === 1) && (
                        <button
                            title="Mark as complete"
                            onClick={() => markComplete(job)}
                            className="btn btn-link btn-success"
                        >
                            <i className="fas fa-check"></i>
                        </button>
                    )}

                    {manager_review && (
                        <button title="Delete" onClick={() => onDelete(job)} className="btn btn-link btn-danger">
                            <i className="fas fa-times"></i>
                        </button>
                    )}

                    <button
                        className="btn btn-link js-toggle-on-hold"
                        title={job.review_on_hold ? 'Remove On Hold' : 'Mark as On Hold'}
                        onClick={() => toggleOnHold(job)}
                    >
                        <i
                            className={`${job.review_on_hold ? 'fas' : 'far'} fa-hand-paper ${
                                job.review_on_hold ? 'text-danger' : ''
                            }`}
                        ></i>
                    </button>
                </td>
            </tr>
        ));

        return (
            <Fragment>
                <table className="table transform-text">
                    <thead>
                        <tr>
                            <th onClick={() => this.handleSort('id')} style={{ cursor: 'pointer' }}>
                                Id{this.renderSortIcons('id')}
                            </th>
                            <th onClick={() => this.handleSort('job_type')} style={{ cursor: 'pointer' }}>
                                Job type{this.renderSortIcons('job_type')}
                            </th>
                            <th onClick={() => this.handleSort('customer')} style={{ cursor: 'pointer' }}>
                                Customer{this.renderSortIcons('customer')}
                            </th>
                            <th onClick={() => this.handleSort('address_line_1')} style={{ cursor: 'pointer' }}>
                                Address line 1{this.renderSortIcons('address_line_1')}
                            </th>
                            <th onClick={() => this.handleSort('postcode')} style={{ cursor: 'pointer' }}>
                                Postcode{this.renderSortIcons('postcode')}
                            </th>
                            <th onClick={() => this.handleSort('city')} style={{ cursor: 'pointer' }}>
                                City{this.renderSortIcons('city')}
                            </th>
                            <th onClick={() => this.handleSort('operative')} style={{ cursor: 'pointer' }}>
                                Operative{this.renderSortIcons('operative')}
                            </th>
                            {manager_review && <th>Review Reason</th>}
                            <th onClick={() => this.handleSort('status')} style={{ cursor: 'pointer' }}>
                                Status{this.renderSortIcons('status')}
                            </th>
                            <th>Actions</th>
                        </tr>
                    </thead>
                    <tbody>{jobs}</tbody>
                </table>
            </Fragment>
        );
    }
}

export default JobList;